import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import MDButton from "../../MDButton";
import { CircularProgress } from "@mui/material";
import { getShift } from "../../../actions/shift/shift";
import { getPeymankar } from "../../../actions/peymankar/peymankar";

ModalSelectShift.propTypes = {
  showModal: PropTypes.any,
  setShowModal: PropTypes.any,
  setData: PropTypes.any,
  onSelectedIdsChange: PropTypes.any,
};
export default function ModalSelectShift({
  showModal,
  setShowModal,
  setData,
  onSelectedIdsChange,
}) {
  const [loading, setLoading] = useState(true);
  const [machines, setMachines] = useState({ data: [] });
  const [selectAll, setSelectAll] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  async function getShifts(term) {
    setLoading(true);
    const data = await getShift({ page:term });
    if (data.message.data.length === 0) {
      setShowModal(false);
      toast.warning("شیفت یافت نشد");
      return;
    }
    setMachines(data.message);
    setLoading(false);
  }
  async function getShiftsWithTerm(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    setLoading(true);
    const data = await getShift({term:formData.get("search")});
    if (data.message.data.length === 0) {
      setLoading(false);
      setMachines({ data: [] });
      toast.warning("شیفت یافت نشد");
      return;
    }
    setMachines(data.message);
    setLoading(false);
  }
  useEffect(() => {
    if (showModal) {
      getShifts(setData);
    }
  }, [showModal]);

  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center w-auto items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="w-auto relative my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-2xl font-semibold" style={{ textWrap: "nowrap" }}>انتخاب شیفت</h3>
                  <form onSubmit={getShiftsWithTerm} className={"relative mx-4 w-full"}>
                    <div className="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                      <svg className="w-4 h-4 text-gray-500 " aria-hidden="true"
                           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                              strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                      </svg>
                    </div>
                    <input type="text" name={"search"} id="default-search"
                           className="block w-full p-2 pe-10 outline-0  text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                           placeholder="جستجو شیفت..." required />
                  </form>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {loading ? (
                  <div className="flex p-6 flex-auto justify-center items-center">
                    <CircularProgress size={30} color={"info"}/>
                  </div>
                ) : (
                  <div>
                    <div className="flex p-6 flex-auto justify-start items-start">
                      <div className="w-full overflow-y-auto h-52">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                          <thead className="w-full text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                              <th scope="col" className="">
                                <div className="flex items-center"></div>
                              </th>
                            </tr>
                          </thead>
                          <tbody className={"w-full"}>
                            {machines.data.map((item, index) => (
                              <tr
                                key={index}
                                className={`w-full bg-white ${
                                  index !== machines.data.length - 1 ? "border-b border-gray" : ""
                                } dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600`}
                              >

                                <th
                                  scope="row"
                                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                >
                                  {item.id}
                                </th>
                                <td className="px-6 py-4">{item.title}</td>
                                <td className="px-6 py-4">
                                  <MDButton
                                    color={"info"}
                                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => {
                                      onSelectedIdsChange({id:item.id,title:item.title});
                                      setShowModal(false);
                                    }}
                                  >
                                    انتخاب
                                  </MDButton>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                <div className="gap-5 flex items-center justify-start p-6 border-t border-solid border-blueGray-200 rounded-b">

                  <MDButton
                    color={"error"}
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    انصراف
                  </MDButton>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
